import { AxiosError } from 'axios';
import { generateQueryString, get } from '@/utils';
import { IAdministrationLog, IAdministrationLogQuery } from './types';

type AdministrationLogsResponse = {
	items: IAdministrationLog[];
	pageNumber: number;
	totalPages: number;
	totalCount: number;
	orderBy: string | null;
	ascending: boolean;
	hasPreviousPage: boolean;
	hasNextPage: boolean;
};

const buildLogsQuery = (
	query: IAdministrationLogQuery | undefined,
	page: number,
	items: number
): string =>
	generateQueryString({
		...query,
		PageNumber: page + 1,
		PageSize: items
	});

async function fetchAdministrationLogs(
	administrationId: number | string,
	page: number,
	items: number,
	query: IAdministrationLogQuery | undefined,
	onResponse?: (page: number, items: number) => void
): Promise<IAdministrationLog[]> {
	try {
		const res = await get(
			`api/administrations/${administrationId}/logs${buildLogsQuery(query, page, items)}`
		);
		const data = res.data as AdministrationLogsResponse;
		onResponse?.(data.totalPages || 1, data.totalCount || 0);
		return data.items || [];
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reușit să accesăm istoricul administrației.');
	}
}

export { fetchAdministrationLogs };
